module.exports = __webpack_public_path__ + "img/private.1c5048f.svg";